import React from "react";
import BetHistory from "../modules/BetHistory/BetHistory";

const BetHistoryPage = () => (
    <BetHistory/>
)

export default BetHistoryPage